import { createFileRoute } from '@tanstack/react-router';

import { ReviewsStatsPage } from '@/features/reviews/stats-page';

export const Route = createFileRoute('/_app/reviews/stats')({
  component: ReviewsStatsPage,
});
